import { plainToClass } from "class-transformer";
import { JsonItem, AppUserRedacted, PickListItem, RevamppCenter, ListInformation, RevamppProject } from "../../../../secure/list-management/scripts/list-management.objects";
import { EditController } from "../../../list-management/scripts/list-management.controllers";
import { Section, SectionField } from "../../../list-management/scripts/list-management.form-sections";
import { getDisplayDate } from "../../../../shared/scripts/date-functions";

export class ProjectManagerProjectPage {
    projectList: RevamppProject[];

    centerPickList: PickListItem[];
    pickLists: JsonItem[];

    editModalId: string;
    projectEditController: EditController;
    currentListController: any;

    pmProjectContainer: JQuery<HTMLElement>;

    constructor(projectList: any, pickLists: any) {
        $(() => {
            this.projectList = plainToClass(RevamppProject, <RevamppProject[]>projectList);
            this.projectList.sort((x1, x2) => x1.ProjectName.localeCompare(x2.ProjectName));
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);
            this.centerPickList = this.pickLists.find(list => list.Id == "pl-center")?.Json;
            this.pmProjectContainer = $("#pm-project-content");

            this.initialize();
        });
    }

    initialize(): void {
        this.initializeEditController();
        let content = this.generateHtml();
        this.pmProjectContainer.empty().html(content);
    }

    initializeEditController(): void {
        this.currentListController = this;
        this.editModalId = "edit-item-modal";
        this.projectEditController = new EditController("pm-project-edit-controller", "Edit Project", "SaveProjects",
            [
                new Section("pm-edit-project-description-section", "Description",
                    [
                        new SectionField("pm-edit-project-public-description", "Public Description", "input-limit-1000", "PublicDescription", true, "", "The project's public description will be displayed on the public-facing page for this Research Center."),
                    ]
                ),
                new Section("pm-edit-project-virus-focus-section", "Virus Focus",
                    [
                        new SectionField("pm-edit-project-virus-family-focus", "Virus Family Focus", "multi-dropdown-pl", "VirusFamilyFocusIds", false, "pl-virus-family"),
                        new SectionField("pm-edit-project-prototype-virus", "Prototype Virus Focus", "pathogen-focus-selection", "PrototypeVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                        new SectionField("pm-edit-project-testcase-virus", "Test Case Virus Focus", "pathogen-focus-selection", "TestCaseVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                    ], "", "", false, true
                ),
                new Section("pm-edit-project-vaccine-antibody-approach-section", "Vaccine/Antibody Approach",
                    [
                        new SectionField("pm-edit-project-vaccine-approach", "Vaccine Platform Approach", "multi-dropdown-pl", "VaccineApproachesIds", false, "pl-vaccine"),
                        new SectionField("pm-edit-project-antibody-approach", "Antibody Platform Approach", "multi-dropdown-pl", "AntibodyApproachesIds", false, "pl-antibody"),
                    ]
                ),
            ]
            , "edit-item-modal", "ProjectName"
        )
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }

    generateHtml(): string {
        let html = ``;
        let centerIds: number[] = [];
        this.projectList.forEach(project => {
            if (!centerIds.includes(project.CenterId)) {
                centerIds.push(project.CenterId);
            }
        });

        centerIds.sort((x1, x2) => {
            let foundCenter1 = this.centerPickList.find(center => center.Id == x1);
            let foundCenter2 = this.centerPickList.find(center => center.Id == x2);
            return foundCenter1?.Value.localeCompare(foundCenter2?.Value);
        });

        centerIds.forEach(centerId => {
            let foundCenter = this.centerPickList.find(center => center.Id == centerId);
            if (foundCenter) {
                let centerContent = "";
                let associatedProjects = this.projectList.filter(project => project.CenterId == centerId);
                associatedProjects.forEach(project => {
                    let projectContent = this.generateHtmlForProject(project);
                    centerContent += projectContent;
                });
                html += `
                    <div class="pm-accordion-title">${foundCenter.Value}</div>
                    <div class="accordion mb-4 pt-2" id="pm-projects-accordion-${centerId}">
                        ${centerContent}
                    </div>
                `
            }
        })

        return html;
    }

    generateHtmlForProject(project: RevamppProject): string {
        let centerAbbreviation = ""
        let foundCenter = this.centerPickList.find(center => center.Id == project.CenterId);
        if (foundCenter) {
            centerAbbreviation = foundCenter.Value;
        }

        let content = `
            <div class="card accordion-item" id="project-${project.Id}">
                <div class="accordion-header collapsed" data-toggle="collapse" data-target="#collapse-${project.Id}">
                    <span class="accordion-title">${project.ProjectName}</span>
                    <span class="arrow">▼</span>
                </div>
                <div class="collapse" id="collapse-${project.Id}" data-parent="#pm-projects-accordion-${project.CenterId}">
                    <div class="card-body">
                        <div class="col-12 border-bottom px-0 pb-3">
                            <div class="row justify-content-between">
                                <div class="col-auto">
                                    <div class="pm-inner-title">${centerAbbreviation} | ${project.ProjectName}</div>
                                    <div class="pm-innter-secondary-title">${project.OrgName}</div>
                                </div>
                                <div class="col-auto">
                                    <div class="text-right font-size15"><b>Last Updated: </b>${getDisplayDate(project.LastUpdated)}</div>
                                </div>
                            </div>            
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Public Description</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-project-description-section', ${project.Id})">Edit Description</div>
                                </div>
                            </div>
                            <div>
                                <p>${project.PublicDescription}</p>
                            </div>
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Virus Focus</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-project-virus-focus-section', ${project.Id})">Edit Virus Focus</div>
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-blue"></span>
                                    Virus Family Focus
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(project.VirusFamilyFocusIds, "pl-virus-family", "light-blue")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-green"></span>
                                    Prototype Virus Focus
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(project.PrototypeVirusIds, "pl-virus", "light-green")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon yellow"></span>
                                    Test Case Virus Focus
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(project.TestCaseVirusIds, "pl-virus", "yellow")}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Vaccine & Antibody Approach</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-project-vaccine-antibody-approach-section', ${project.Id})">Edit Approach</div>
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-blue"></span>
                                    Vaccine Approaches
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(project.VaccineApproachesIds, "pl-vaccine", "light-blue")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-green"></span>
                                    Antibody Approaches
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(project.AntibodyApproachesIds, "pl-antibody", "light-green")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `
        return content;
    }

    generatePillContent(idString: string, pickList: string, color: string): string {
        if (idString == null || idString == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>"
        }
        let foundPickList: PickListItem[] = this.pickLists.find(list => list.Id == pickList)?.Json;
        if (!foundPickList) {
            return "<div class='error-msg col-auto'>--No Pick List Found--</div>"
        }

        let idArr: string[] = idString.split("|");
        let valArr: string[] = [];
        let returnContent: string = ``;
        idArr.forEach(id => {
            let foundItem = foundPickList.find(item => item.Id.toString() == id);
            if (foundItem) {
                valArr.push(foundItem.Value);
            }
        });
        valArr.sort();
        valArr.forEach(val => {
            returnContent += `
                <div class="col-auto pr-0 mb-2">
                    <div class="pill-list-item ${color}">${val}</div>
                </div>`
        })

        if (returnContent == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>";
        }
        return returnContent;
    }

    updateProjectDisplay(projects: RevamppProject[]) {
        projects.forEach(project => {
            let previousProjectIndex = this.projectList.findIndex(prevProject => prevProject.Id == project.Id);
            if (previousProjectIndex >= 0) {
                this.projectList.splice(previousProjectIndex, 1, project);
            }
            let newContent: string = this.generateHtmlForProject(project);
            $(`#project-${project.Id}`).replaceWith(newContent);
            $(`#project-${project.Id}`).find(".accordion-header").trigger('click');
        })
    }

    openEditModal(sectionId: string, targetId: number) {
        this.projectEditController.showLoading(false);

        let foundProject = this.projectList.find(project => project.Id == targetId);
        if (foundProject) {
            this.projectEditController.initialize(this.pickLists, [foundProject], sectionId);
            $(`#${this.editModalId}`).modal('show');
        }
    }

    async saveEditModal() {
        // if it isn't valid, don't save
        let isValid = this.projectEditController.validate();
        if (!isValid) {
            return;
        }
        else {
            // show saving on edit modal
            this.projectEditController.showLoading(true);

            // saves changes to DB (returns updated items)
            let result: any[] = await this.projectEditController.save();

            // reinitialze
            this.updateProjectDisplay(result);

            // Show Saved
            this.projectEditController.showSaved(true);


            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.editModalId}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.projectEditController.showLoading(false);
                    this.projectEditController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }
}